import script from "./SubmissionListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionListPage.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionListPage.vue?vue&type=style&index=0&id=5f877f24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f877f24"]])

export default __exports__